/**
 * Created by MinhQuan on 8/1/2016.
 */
angular.module('taric.duty.calculate.security', ['taric.model.cd', 'common.filter.description', 'common.filter.decimalNumberCalcResult']).controller('CalculateDutySecurityCtrl', function (CalculateDutyModel) {
    var calculateDutySecurityCtrl = this;
    calculateDutySecurityCtrl.init = function () {
        calculateDutySecurityCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
        calculateDutySecurityCtrl.quotaSecurities = CalculateDutyModel.quotaSecurities;
        calculateDutySecurityCtrl.measureMap = {};
        for (let i = 0; i < CalculateDutyModel.getCalculationResult().measures.length; i++) {
            calculateDutySecurityCtrl.measureMap[CalculateDutyModel.getCalculationResult().measures[i].sid] = CalculateDutyModel.getCalculationResult().measures[i];
        }
    };
    calculateDutySecurityCtrl.next = function () {
        calculateDutySecurityCtrl.navigatingToNextTab = true;
        CalculateDutyModel.goToNextTab('security').then(function(){
            calculateDutySecurityCtrl.navigatingToNextTab = false;
        }, function (error) {
            calculateDutySecurityCtrl.updateError(error);
            calculateDutySecurityCtrl.navigatingToNextTab = false;

        });
    };

    calculateDutySecurityCtrl.updateError = function(error){
        if (!error){
            calculateDutySecurityCtrl.errorCode = null;
            calculateDutySecurityCtrl.errorParams = null;
            calculateDutySecurityCtrl.errorType = null;
        } else {
            calculateDutySecurityCtrl.errorCode = error.data.code;
            calculateDutySecurityCtrl.errorParams = error.data.params;
            calculateDutySecurityCtrl.errorType = error.data.errorType;
        }
    };

});





// WEBPACK FOOTER //
// ./app/taric/duties/calculate/security/cd-security.js